export default {
  id: 187,
  title: 'Target #187 - Striped Triangle',
  url: 'https://cssbattle.dev/play/187',
  colors: ['#40234B', '#A94EA4'],
  solution:
    '<p a><p b><style>body,p[b]{background:#40234b}p{position:fixed}p[a]{top:34;left:85;border-style:solid;border-width:200 115;border-color:#a94ea4 #40234b #40234b}p[b]{top:-100;left:93;width:10;height:300;rotate:30deg;box-shadow:26px 0 #40234b,52px 0 #40234b,78px 0 #40234b,104px 0 #40234b,130px 0 #40234b,156px 0 #40234b',
}
